import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-clm-res-accessories',
    imports: [FormsModule, MatIcon],
    templateUrl: './clm-res-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-res-accessories.component.css'
})
export class ClmResAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  emergencyHeaterSelection!: GuruEntity;
  thermostatSelection!: GuruEntity;
  wallPlateSelection!: GuruEntity;
  outdoorTemperatureSensorSelection!: GuruEntity;
  antiScaldValveSelection!: GuruEntity;
  compressorSoftStartKitSelection!: GuruEntity;
  unitPadSelection!: GuruEntity;
  packagedUnitStandSelection!: GuruEntity;
  extendedWarrantySelection!: GuruEntity;
  smartTankSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.emergencyHeaterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USElecHtKw');
    this.thermostatSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.wallPlateSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWallPlate');
    this.outdoorTemperatureSensorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTempSensor');
    this.antiScaldValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAntiScaldValve');
    this.compressorSoftStartKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSoftStartKit');
    this.unitPadSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitPad');
    this.packagedUnitStandSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitStand');
    this.extendedWarrantySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWarranty');
    this.smartTankSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSmartTank');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
